import { Observable } from 'rxjs';
import { CompanyTypeModel, CompanyRequest, CompanyDefaultModel} from '@src/core/domain/company/companyType.model';

export abstract class CompanyTypeRepository {
  abstract getCompanyTypes(): Observable<CompanyTypeModel>;
  abstract getCompanyDefault(): Observable<CompanyDefaultModel>;
  abstract setCompanyIndex(obj: CompanyRequest): Observable<CompanyTypeModel>;
}
